const featureFlags = {
  devtoolsEnabled: import.meta.env.VITE_FEATURE_DEVTOOLS_ENABLED === 'true',
  surveyFeatureEnabled:
    import.meta.env.VITE_FEATURE_QUALTRICS_SURVEY_ENABLED === 'true',
  notifyRoutingPlansEnabled:
    import.meta.env.VITE_FEATURE_NOTIFY_ROUTING_PLANS_ENABLED === 'true',
  manageUserDetails:
    import.meta.env.VITE_FEATURE_MANAGE_USER_DETAILS === 'true',
  dryRunEnabled: import.meta.env.VITE_FEATURE_DRY_RUN_ENABLED === 'true',
  campaignTemplates: import.meta.env.VITE_FEATURE_CAMPAIGN_TEMPLATES === 'true',
  legacyMessagePlansEnabled: import.meta.env.VITE_FEATURE_LEGACY_MESSAGE_PLANS_ENABLED === 'true',
  notificationsEnabled: import.meta.env.VITE_FEATURE_NOTIFICATIONS_ENABLED === 'true',
};

export default featureFlags;
